<template>
  <span>
    <AtomText
      v-if="hasDiscount"
      is-tag="span"
      font-size="text-base"
      color-variant="description"
      class="mr-2 line-through"
      :text="formatEuroPrice(price)"
      data-cy="price-before-discount"
    />
    <AtomText
      is-tag="span"
      font-size="text-3xl"
      font-style="font-bold"
      :text="displayedPrice"
      class="mr-1"
      data-cy="displayed-price"
    />
    <AtomText
      v-if="!isOffered"
      is-tag="span"
      font-size="text-sm"
      font-style="font-semibold"
      :text="t('subscription.solarProductionStorage.batteryStorage.common.priceUnit')"
    />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { formatEuroPrice } from '@/utils/format.util';

const props = withDefaults(
  defineProps<{
    price: number | null;
    discountedPrice?: number | null;
  }>(),
  { discountedPrice: null }
);

const { t } = useI18n();

const hasDiscount = computed(() => props.discountedPrice !== null);

const isOffered = computed(() => props.discountedPrice === 0);

const displayedPrice = computed(() => {
  if (isOffered.value) {
    return t('subscription.solarProductionStorage.batteryStorage.common.offered');
  }

  return formatEuroPrice(hasDiscount.value ? props.discountedPrice : props.price);
});
</script>
